import { styled } from '@linaria/react';
import { colors, fonts, layout, space } from '../../theme/tokens';

export const StyledButton = styled.button<{
  $fullWidth: boolean;
}>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: ${fonts.body};
  font-weight: ${fonts.weight.semiBold};
  line-height: 1;
  border-radius: 30px;
  cursor: pointer;
  transition: all 0.2s ease;
  text-decoration: none;
  width: ${({ $fullWidth }) => ($fullWidth ? '100%' : 'auto')};

  padding: 12px 24px;
  font-size: ${fonts.size.md};

  &[data-size='small'] {
    padding: 8px 16px;
    font-size: ${fonts.size.sm};
  }

  &[data-size='large'] {
    padding: 16px 32px;
    font-size: ${fonts.size.base};
  }

  background-color: ${colors.secondary};
  color: ${colors.white};
  border: 2px solid ${colors.secondary};

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &:focus-visible {
    outline: 2px solid ${colors.primary};
    outline-offset: 2px;
  }

  &:hover:not(:disabled) {
    opacity: 0.85;
  }

  &[data-variant='secondary'] {
    background-color: ${colors.lighterGrey};
    color: ${colors.fontPrimary};
    border: 2px solid ${colors.lighterGrey};

    &:hover:not(:disabled) {
      background-color: ${colors.lightGrey};
      border-color: ${colors.lightGrey};
      opacity: 1;
    }
  }

  &[data-variant='outline'] {
    background-color: transparent;
    color: ${colors.fontPrimary};
    border: 2px solid ${colors.fontPrimary};

    &:hover:not(:disabled) {
      background-color: ${colors.fontPrimary};
      color: ${colors.white};
      opacity: 1;
    }
  }

  &[data-variant='toggle'] {
    background-color: transparent;
    color: ${colors.fontPrimary};
    border: 1px solid ${colors.borderGrey};
    border-radius: 8px;
    font-weight: ${fonts.weight.medium};

    &:hover:not(:disabled) {
      background-color: ${colors.lighterGrey};
      border-color: ${colors.borderGrey};
      color: ${colors.fontPrimary};
    }

    &[data-selected] {
      background-color: var(--voyager-color-toggleSelected, #6b21a8);
      border-color: var(--voyager-color-toggleSelected, #6b21a8);
      color: ${colors.white};

      &:hover:not(:disabled) {
        background-color: var(--voyager-color-toggleSelectedHover, #581c87);
        border-color: var(--voyager-color-toggleSelectedHover, #581c87);
        color: ${colors.white};
      }
    }
  }

  &[data-variant='icon'] {
    height: 40px;
    padding: ${space[2]} ${space[4]};
    border-radius: ${layout.borderRadiusFull};
    background: ${colors.lighterGrey};
    color: ${colors.fontPrimary};
    border: none;

    &:hover:not(:disabled) {
      background: ${colors.lightGrey};
      opacity: 1;
    }
  }

  &[data-variant='icon-ghost'] {
    height: 40px;
    padding: ${space[1]} ${space[4]};
    border-radius: ${layout.borderRadiusFull};
    background: transparent;
    color: ${colors.fontPrimary};
    border: none;

    &:focus-visible {
      outline-offset: -2px;
    }

    &:hover:not(:disabled) {
      background: ${colors.lightGrey};
      opacity: 1;
    }
  }
`;
